import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import flyInRightGif from '../../../assets/images/transitions/flyInRight.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_IN_EDGE_RIGHT = 'easeInEdgeRight';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeInEdgeRightPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_IN_EDGE_RIGHT,

  // A human friendly name for the preset.
  humanName: 'Ease In From Edge Right',

  // A preview of the transition.
  gif: flyInRightGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'position.x': {
      time: {
        start: 'start.0',
        end: 'start.1000'
      },
      easing: EASINGS.easeOutPower3,
      values: [
        'off.right',
        'position.right'
      ],
      immediateRender: true
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_IN_EDGE_RIGHT,
    options: {},
  },
};

easeInEdgeRightPresetDetails.template.options = lodash.cloneDeep(easeInEdgeRightPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_IN_EDGE_RIGHT;

// This defines the value of the presets object.
export default easeInEdgeRightPresetDetails;
